import type { BuildingDto } from "@klantpunt/shared";
import { PanelHead, useSwipeClose } from "../../app/DetailPanel";
import { ObligationSection } from "./ObligationSection";

/** `selAsset` in het gebouw: dit paneel in plaats van een asset (ook via `?gebouw=1`). */
export const BUILDING_OWNER = "gebouw";

/**
 * Onderhoud en keuringen bij het gebouw zelf, zonder asset (docs/ASSETS-MJOP.md, "Bij het gebouw"): bijvoorbeeld
 * de gevelinspectie of dakgoten reinigen. Zelfde kaarten, formulier en vastleggen als bij een asset.
 */
export function BuildingObligationsPanel({ building: b, onClose }: { building: BuildingDto; onClose: () => void }) {
  const swipeRef = useSwipeClose<HTMLDivElement>(onClose);
  return (
    <div ref={swipeRef} className="detail" role="region" aria-label="Onderhoud en keuringen bij het gebouw">
      <PanelHead
        code={b.code}
        chip={<span className="chip small">Gebouw</span>}
        title="Bij het gebouw"
        onClose={onClose}
      />
      <div className="dbody">
        <p className="muted small">
          Onderhoud en keuringen die bij het gebouw horen en niet bij één asset, zoals de gevelinspectie of dakgoten
          reinigen.
        </p>
        <ObligationSection asset={null} buildingId={b.id} buildingLabel={`${b.code} · ${b.name}`} />
      </div>
    </div>
  );
}
